import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import DashboardLayout from '../layouts/DashboardLayout';
import ForgotPassword from '../pages/ForgotPassword';
import AuthenticationLayout from '../layouts/AuthenticationLayout';
import Login from '../pages/Login';
import Contracts from '../pages/dashboard/sales/contracts/Contracts';
import ContractDetails from '../pages/dashboard/sales/contracts/ContractDetails';
import Invoices from '../pages/dashboard/sales/invoices/Invoices';
import InvoiceDetails from '../pages/dashboard/sales/invoices/InvoiceDetails';
import SettingsContainer from '../pages/dashboard/settings/SettingsContainer';
import UserProfileSettings from '../pages/dashboard/settings/UserProfileSettings';
import { ErrorBoundary } from '../components/ErrorBoundary';
import NoAccessPage from '../layouts/NoAccessPage';
import { InsuranceOverview } from '../pages/dashboard/insurance/InsuranceOverview';
import { InsuranceProfileForm } from '../pages/dashboard/insurance/InsuranceProfileForm';
import Financing from '../pages/dashboard/financing/financing';
import { FinanceOverview } from '../pages/dashboard/financing/FinanceOverview';
import Requestexportfinance from '../pages/dashboard/financing/requestexportfinance/requestexportfinance';
import Viewfinanceapplication from '../pages/dashboard/financing/viewfinanceapplication/viewfinanceapplication';
import Bookings from '../pages/dashboard/bookings/bookings';
import CreateBooking from '../pages/dashboard/bookings/createbooking/CreateBooking';
import Viewbookings from '../pages/dashboard/bookings/viewbookings/viewbookings';
import Trackshipment from '../pages/dashboard/bookings/trackshipment/trackshipment';
import TrackshipmentInternal from '../pages/dashboard/bookings/trackshipment/trackshipmentinternal';
import BookingDetails from '../pages/dashboard/bookings/overview/BookingDetails';
import BookingProfileDetails from '../pages/dashboard/bookings/overview/BookingProfileDetails';
import ShippingProfileDetails from '../pages/dashboard/bookings/overview/ShippingProfileDetails';
import BookingOverviewNew from '../pages/dashboard/bookings/overview/BookingOverviewNew';
import OceanSchedules from '../pages/dashboard/ocean-schedules/ocean-schedules';
import PaymentsOverview from '../pages/dashboard/payments/PaymentsOverview';
import PaymentTable from '../pages/dashboard/payments/PaymentTable';
import MakePayment from '../pages/dashboard/payments/makepayment/makepayment';
import ViewTransaction from '../pages/dashboard/payments/ViewTransaction';
import { LogisticsInvoiceContainer } from '../pages/dashboard/payments/LogisticsInvoiceContainer';
import { LogisticsInvoiceHome } from '../pages/dashboard/payments/LogisticsInvoiceHome';
import { LogisticsInvoiceCreate } from '../pages/dashboard/payments/LogisticsInvoiceCreate';
import { LogisticsInvoiceList } from '../pages/dashboard/payments/LogisticsInvoiceList';
import LogisticsInvoiceDetails from '../pages/dashboard/payments/LogisticsInvoiceDetails';
import { LogisticsInvoicePayDetails } from '../pages/dashboard/payments/LogisticsInvoicePayDetails';
import CurrencyAdministration from '../pages/dashboard/payments/CurrencyAdministration';
import DedicatedAccounts from '../pages/dashboard/payments/dedicatedAccounts/DedicatedAccounts';
import DedicatedAccountDetails from '../pages/dashboard/payments/dedicatedAccounts/DedicatedAccountDetails';
import StockManagement from '../pages/dashboard/stock';
import Inspection from '../pages/dashboard/inspection/Inspection';
import TradeDocumentNew from '../pages/dashboard/tradedocuments/TradeDocumentNew';
import SalesContractNew from '../pages/dashboard/tradedocuments/salescontract/SalesContractNew';
import QuotationNew from '../pages/dashboard/tradedocuments/quotation/QuotationNew';
import ProformaInvoiceNew from '../pages/dashboard/tradedocuments/proformainvoice/ProfomaInvoiceNew';
import CommercialInvoiceNew from '../pages/dashboard/tradedocuments/commercialinvoice/CommercialInvoiceNew';
import PackingList from '../pages/dashboard/tradedocuments/parkinglist/PackingList';
import Billoflading from '../pages/dashboard/tradedocuments/billoflading/billoflading';
import PurchaseOrderNew from '../pages/dashboard/tradedocuments/purchaseorder/PurchaseOrderNew';
import VerifiedGrossMassDeclarationNew from '../pages/dashboard/tradedocuments/verifiedgrossmassdeclaration/VerifiedGrossMassDeclarationNew';
import HouseBillOfLadingNew from '../pages/dashboard/tradedocuments/housebilloflading/HouseBillOfLadingNew';
import CertificateOfOriginNew from '../pages/dashboard/tradedocuments/housebilloflading/certificateoforigin/CertificateOfOriginNew';
import ViewCorporates from '../pages/dashboard/corporates/ViewCorporates';
import CorporatesNew from '../pages/dashboard/corporates/CorporatesNew';
import ResetPassword from '../pages/ResetPassword';
import Dashboardmain from '../pages/dashboard/dashboardmain/dashboardmain';
import SignUp from '../pages/SignUp';
import VerifyAccount from '../pages/verifyaccount/verifyaccount';
import TreasuryManagement from '../pages/dashboard/treasury-management/Overview/TreasuryManagement';
import TransactionsDetails from '../pages/dashboard/treasury-management/TransactionsDetails';
import UserManagement from '../pages/dashboard/settings/UserManagement/UserManagement';
import InvitedUserPassword from '../pages/InvitedUserPassword';
import TreasuryOverview from '../pages/dashboard/treasury-management/Overview/TreasuryOverview';
import TreasuryAccounts from '../pages/dashboard/treasury-management/Overview/TreasuryAccounts';
import TreasuryTransactions from '../pages/dashboard/treasury-management/Overview/TreasuryTransactions';
import Investments from '../pages/dashboard/investment/Investments';
import { Onboarding } from '../pages/dashboard/investment/Onboarding/Onboarding';

export const BaseRoutes = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<AuthenticationLayout />}>
                    <Route index element={<Login />} />
                    <Route path='login' element={<Login />} />
                    <Route path='signup' element={<SignUp />} />
                    <Route path='password/reset' element={<ResetPassword />} />
                    <Route
                        path='password/forgot'
                        element={<ForgotPassword />}
                    />
                    <Route
                        path='verify/account/:verificationCode'
                        element={<VerifyAccount />}
                    />
                    <Route
                        path='invited-user/password'
                        element={<InvitedUserPassword />}
                    />
                </Route>
                <Route path='/' element={<DashboardLayout />}>
                    <Route index element={<Dashboardmain />} />
                    <Route path='/dashboard' element={<Dashboardmain />} />

                    {/* Sales Routes */}
                    <Route path='/sales'>
                        <Route path='contracts' element={<Contracts />} />
                        <Route
                            path='contracts/details/:contractNumber'
                            element={<ContractDetails />}
                        />
                        <Route path='invoices' element={<Invoices />} />
                        <Route
                            path='invoices/details/:reference'
                            element={<InvoiceDetails />}
                        />
                    </Route>

                    {/* Treasury management Routes*/}
                    <Route path='/treasury' element={<TreasuryManagement />}>
                        <Route path='overview' element={<TreasuryOverview />} />

                        <Route path='accounts' element={<TreasuryAccounts />} />
                        <Route
                            path='transactions'
                            element={<TreasuryTransactions />}
                        />
                        <Route
                            path='accounts/:id'
                            element={<TransactionsDetails />}
                        />
                    </Route>

                    <Route path='/investment' element={<Investments />}></Route>

                    <Route
                        path='/onboarding/investment'
                        element={<Onboarding />}
                    />

                    {/* Bookings Route */}
                    <Route path='/bookings'>
                        <Route index element={<Bookings />} />
                        <Route
                            path='overview'
                            element={<BookingOverviewNew />}
                        />
                        <Route
                            path='create-booking'
                            element={<CreateBooking />}
                        />
                        <Route path=':reference' element={<Viewbookings />} />
                        <Route
                            path='track-shipments'
                            element={<Trackshipment />}
                        />
                        <Route
                            path='track-shipments/:reference'
                            element={<TrackshipmentInternal />}
                        />
                        <Route
                            path='track-shipments/:reference/:containerNumber'
                            element={<TrackshipmentInternal />}
                        />
                        <Route
                            path=':reference/details'
                            element={<BookingDetails />}
                        />
                        <Route
                            path='booking-profile/:reference/details'
                            element={<BookingProfileDetails />}
                        />
                        <Route
                            path='shipping-profile/:reference/details'
                            element={<ShippingProfileDetails />}
                        />
                        <Route
                            path='ocean-schedules'
                            element={<OceanSchedules />}
                        />
                    </Route>

                    {/* Financing Route */}
                    <Route path='/financing'>
                        <Route index element={<Financing />} />
                        <Route path='overview' element={<FinanceOverview />} />
                        <Route
                            path='/financing/export-finance/request'
                            element={<Requestexportfinance />}
                        />
                        <Route
                            path='/financing/application/:reference'
                            element={<Viewfinanceapplication />}
                        />
                    </Route>

                    {/* Insurance Route */}
                    <Route path='/insurance'>
                        <Route index element={<InsuranceOverview />} />
                        <Route
                            path='profile'
                            element={<InsuranceProfileForm />}
                        />
                    </Route>

                    {/* Payment Route */}
                    <Route path='/payments'>
                        <Route path='' element={<PaymentsOverview />}>
                            <Route path=':view' element={<PaymentTable />} />
                            <Route
                                path='make-payment'
                                element={<MakePayment />}
                            />
                        </Route>
                        <Route
                            path='transactions/:reference'
                            element={<ViewTransaction />}
                        />
                        <Route
                            path='currency-administration'
                            element={<CurrencyAdministration />}
                        />
                        <Route
                            path='dedicated-accounts'
                            element={<DedicatedAccounts />}
                        />
                        <Route
                            path='dedicated-accounts/:id'
                            element={<DedicatedAccountDetails />}
                        />
                        <Route
                            path='logistics'
                            element={<LogisticsInvoiceContainer />}
                        >
                            <Route path='' element={<LogisticsInvoiceHome />} />
                            <Route
                                path='create'
                                element={<LogisticsInvoiceCreate />}
                            />
                            <Route
                                path='list'
                                element={<LogisticsInvoiceList />}
                            />
                            <Route
                                path='details/:reference'
                                element={<LogisticsInvoiceDetails />}
                            />
                            <Route
                                path='pay'
                                element={<LogisticsInvoicePayDetails />}
                            />
                        </Route>
                    </Route>

                    {/* Trade Documents Route */}
                    <Route path='/trade-documents'>
                        <Route index element={<TradeDocumentNew />} />
                        <Route
                            path='sales-contract'
                            element={<SalesContractNew />}
                        />
                        <Route path='quotation' element={<QuotationNew />} />
                        <Route
                            path='proforma-invoice'
                            element={<ProformaInvoiceNew />}
                        />
                        <Route
                            path='commercial-invoice'
                            element={<CommercialInvoiceNew />}
                        />
                        <Route path='packing-list' element={<PackingList />} />
                        <Route
                            path='bill-of-lading'
                            element={<Billoflading />}
                        />
                        <Route
                            path='purchase-order'
                            element={<PurchaseOrderNew />}
                        />
                        <Route
                            path='verified-gross-mass-declaration'
                            element={<VerifiedGrossMassDeclarationNew />}
                        />
                        <Route
                            path='certificate-of-origin'
                            element={<CertificateOfOriginNew />}
                        />
                        <Route
                            path='house-bill-of-lading'
                            element={<HouseBillOfLadingNew />}
                        />
                    </Route>

                    {/* Stock Route */}
                    <Route path='/stock'>
                        <Route index element={<StockManagement />} />
                        <Route
                            path='add-warehouse'
                            element={<InsuranceProfileForm />}
                        />
                    </Route>

                    {/* Inspection Route */}
                    <Route path='/inspection' element={<Inspection />} />

                    {/* Settings Route */}
                    <Route path='/settings' element={<SettingsContainer />}>
                        <Route
                            path='profile'
                            element={<UserProfileSettings />}
                            errorElement={<ErrorBoundary />}
                        />
                        <Route
                            path='user-management'
                            element={<UserManagement />}
                            errorElement={<ErrorBoundary />}
                        />
                    </Route>

                    {/* Corporates Route */}
                    <Route path='/corporates'>
                        <Route index element={<CorporatesNew />} />
                        <Route
                            path=':corporateId'
                            element={<ViewCorporates />}
                        />
                    </Route>

                    {/* 404 Route */}
                    <Route path='*' element={<NoAccessPage />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
};
